import { render, staticRenderFns } from "./video-modal.vue?vue&type=template&id=3379f14f&"
import script from "./video-modal.vue?vue&type=script&lang=js&"
export * from "./video-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports